import AppRoutes from '@/routes/AppRoutes';
import { useSsoLogin } from '@gyandiksha/shared-ui/hooks';
import ComponentNavigation from '@/navigation/ComponentNavigation';

const App = () => {

  // This will handle the ERP User SSO login process.
  const isERPUserLoginReady = useSsoLogin();

  if (!isERPUserLoginReady) {
    return null;
  }

  return (
    <div>
      <AppRoutes componentRoutes={ComponentNavigation} />
    </div>
  )
}

export default App
